// Traducciones al inglés: clave = texto en español exactamente como en el código.
// Personas: lista, ficha, formulario, listas, seguimiento, formularios, campos e importación.
export default {
  // Navegación del módulo
  'Seguimiento': 'Workflows',
  'Formularios': 'Forms',
  'Campos': 'Fields',
  'Importar CSV': 'Import CSV',

  // Etiquetas compartidas
  'Miembro': 'Member',
  'Asistente regular': 'Regular attender',
  'Visitante': 'Visitor',
  'Participante': 'Participant',
  'Ninguna': 'None',
  'Soltero/a': 'Single',
  'Casado/a': 'Married',
  'Viudo/a': 'Widowed',
  'Divorciado/a': 'Divorced',
  'Separado/a': 'Separated',
  'Masculino': 'Male',
  'Femenino': 'Female',
  'Nombre@@completo': 'Name',
  'Nombre@@genérico': 'Name',
  'Estado': 'Status',
  'Estado@@dirección': 'State',
  'Activo': 'Active',
  'Inactivo': 'Inactive',
  'Activa': 'Active',
  'Membresía': 'Membership',
  'Género': 'Gender',
  'Estado civil': 'Marital status',
  'Aniversario': 'Anniversary',
  'Escuela': 'School',
  'Grado': 'Grade',
  'Tipo': 'Type',
  'Fecha': 'Date',
  'Contacto': 'Contact',
  'Principal': 'Primary',
  'Celular': 'Mobile',
  'Casa': 'Home',
  'Trabajo': 'Work',
  'Teléfono': 'Phone',
  'Niño/a': 'Child',
  'Hijo/a': 'Child',
  'Adulto': 'Adult',
  '{n} año@@edad': '{n} year old',
  '{n} años@@edad': '{n} years old',

  // Lista de personas
  '{n} resultado': '{n} result',
  '{n} resultados': '{n} results',
  '+ Nueva persona': '+ New person',
  'Nueva persona': 'New person',
  'Nombre, correo o teléfono': 'Name, email or phone',
  'Activos': 'Active',
  'Inactivos': 'Inactive',
  'Adultos y niños': 'Adults and children',
  'Adultos': 'Adults',
  'Niños@@tipo': 'Children',
  'Prueba con otra búsqueda o filtro.': 'Try a different search or filter.',

  // Formulario de persona
  'Segundo nombre': 'Middle name',
  'Apodo': 'Nickname',
  'Cómo le gusta que le llamen': 'What they like to be called',
  'Fecha de nacimiento': 'Birthdate',
  'Campus principal': 'Primary campus',
  'Sin campus': 'No campus',
  'Es niño/a': 'Is a child',
  'Grado escolar': 'School grade',
  'Notas médicas y alergias': 'Medical notes and allergies',
  'Se guardan cifradas. Aparecen en la etiqueta de check-in del niño.': 'Stored encrypted. Shown on the child’s check-in label.',
  'Motivo': 'Reason',
  'Correos': 'Emails',
  'correo@ejemplo.org': 'email@example.org',
  '+ Correo': '+ Email',
  'Teléfonos': 'Phones',
  '+ Teléfono': '+ Phone',
  'Direcciones': 'Addresses',
  'Calle y número': 'Street address',
  'Apto, suite (opcional)': 'Apt, suite (optional)',
  'Ciudad': 'City',
  'Código postal': 'ZIP code',
  'Quitar dirección': 'Remove address',
  '+ Dirección': '+ Address',

  // Listas dinámicas
  'Edad (años)': 'Age (years)',
  'Mes de cumpleaños': 'Birthday month',
  'Registrado en los últimos N días': 'Added in the last N days',
  'Está en el grupo (id)': 'Is in group (ID)',
  'Está en el equipo (id)': 'Is on team (ID)',
  'Tiene correo': 'Has email',
  'Tiene celular': 'Has mobile phone',
  'Asistió (check-in) en los últimos N días': 'Checked in within the last N days',
  'NO asistió en los últimos N días': 'Did NOT check in within the last N days',
  'es igual a': 'equals',
  'no es': 'is not',
  'es mayor o igual a': 'is greater than or equal to',
  'es menor o igual a': 'is less than or equal to',
  'está en': 'is in',
  'Grupos de personas que se actualizan solos según reglas.': 'Groups of people that update automatically based on rules.',
  '{n} regla': '{n} rule',
  '{n} reglas': '{n} rules',
  'Lista creada': 'List created',
  'Coincidencia': 'Match',
  'Cumple todas las reglas': 'Matches all rules',
  'Cumple al menos una regla': 'Matches at least one rule',
  'Elige…': 'Choose…',
  'valor': 'value',
  '+ Regla': '+ Rule',
  'Valores:': 'Values:',
  'género': 'gender',
  'membresía': 'membership',
  'sí/no': 'yes/no',
  'Lista': 'List',
  '{n} persona': '{n} person',
  '{n} personas': '{n} people',
  'Nadie cumple estas reglas': 'No one matches these rules',

  // Seguimiento
  'Llamada de bienvenida': 'Welcome call',
  'Invitación a café': 'Coffee invitation',
  'Conectar a un grupo': 'Connect to a group',
  'Flujos para acompañar a visitantes nuevos, bautismos, consejería…': 'Workflows to follow up with new visitors, baptisms, counseling…',
  '+ Nuevo flujo': '+ New workflow',
  'Sin flujos': 'No workflows',
  'Nuevo flujo': 'New workflow',
  'Pasos (uno por línea)': 'Steps (one per line)',
  'Agregar persona al flujo': 'Add person to workflow',
  'Completar ✓': 'Complete ✓',
  'Siguiente →': 'Next →',

  // Formularios
  'Petición de oración': 'Prayer request',
  'Formularios públicos: tarjeta de conexión, peticiones, voluntariado…': 'Public forms: connection card, prayer requests, volunteering…',
  '+ Nuevo formulario': '+ New form',
  '{n} respuesta': '{n} response',
  '{n} respuestas': '{n} responses',
  'Enlace público ↗': 'Public link ↗',
  'Respuestas': 'Responses',
  'Sin formularios': 'No forms',
  'Nuevo formulario': 'New form',
  'Siempre se piden nombre, apellido y correo. Agrega preguntas adicionales:': 'First name, last name and email are always requested. Add more questions:',
  'clave': 'key',
  'Pregunta': 'Question',
  'Texto': 'Text',
  'Párrafo': 'Paragraph',
  'Sí/No': 'Yes/No',
  'Obligatoria': 'Required',
  '+ Pregunta': '+ Question',
  'Sin respuestas aún': 'No responses yet',

  // Campos personalizados
  'Número': 'Number',
  'Lista@@tipo de campo': 'Dropdown',
  'Varias opciones': 'Multiple choice',
  'Campos personalizados': 'Custom fields',
  'Datos propios de tu iglesia en la ficha de cada persona.': 'Your church’s own data on each person’s profile.',
  'Nuevo campo': 'New field',
  'Sección': 'Section',
  'Opciones (separadas por coma)': 'Options (comma-separated)',
  'Sin campos': 'No fields',

  // Importar CSV
  'Importar personas (CSV)': 'Import people (CSV)',
  'Desde Excel u otro sistema. Primero se revisa sin guardar nada.': 'From Excel or another system. The file is checked first, without saving anything.',
  'Columnas aceptadas (en español o inglés): nombre, apellido, correo, teléfono, fecha de nacimiento (AAAA-MM-DD o MM/DD/AAAA), género (M/F), campus (código o nombre), membresía, hogar (mismo valor = misma familia), grado, calle, ciudad, estado, código postal, idioma (español/inglés), id_externo. Si una persona ya existe (por id externo o correo), se actualiza.':
    'Accepted columns (in English or Spanish): first_name, last_name, email, phone, birthdate (YYYY-MM-DD or MM/DD/YYYY), gender (M/F), campus (code or name), membership, household (same value = same family), grade, street, city, state, zip, language (Spanish/English), remote_id. If a person already exists (by remote ID or email), they are updated.',
  'Revisar archivo': 'Check file',
  'Importar': 'Import',
  'Importación completa: {created} creadas, {updated} actualizadas.': 'Import complete: {created} created, {updated} updated.',
  '{rows} filas · {created} nuevas · {updated} existentes por actualizar · {errors} con errores.': '{rows} rows · {created} new · {updated} existing to update · {errors} with errors.',
  'Corrige el archivo y vuelve a revisarlo.': 'Fix the file and check it again.',
  'Todo listo para importar.': 'Everything is ready to import.',
  'Fila': 'Row',
  'Problema': 'Issue',

  // Ficha de la persona
  'Editar datos': 'Edit details',
  'Notas médicas:': 'Medical notes:',
  'Perfil': 'Profile',
  'Notas ({n})': 'Notes ({n})',
  'Grupos y equipos': 'Groups and teams',
  'Verificación y acceso': 'Background check and access',
  'Sin datos de contacto.': 'No contact info.',
  'Datos': 'Details',
  'Nombre completo': 'Full name',
  'Nacimiento': 'Birthdate',
  'Registrado': 'Added',
  'Líder': 'Leader',
  'No participa en grupos.': 'Not in any groups.',
  'Equipos de servicio': 'Serving teams',
  'No está en ningún equipo.': 'Not on any team.',
  'Flujos de seguimiento': 'Workflows',
  'Completada': 'Completed',
  'No está en ningún flujo.': 'Not in any workflow.',
  'Datos actualizados': 'Details updated',
  'Editar contacto': 'Edit contact info',
  'Contacto actualizado': 'Contact info updated',
  'Familia {lastName}': '{lastName} Family',
  'Hogar': 'Household',
  '+ Agregar': '+ Add',
  'No pertenece a ningún hogar.': 'Not part of any household.',
  'Agregar al hogar': 'Add to household',
  'Rol': 'Role',
  'Buscar persona': 'Find a person',
  'Autorizados para recoger': 'Authorized for pickup',
  'Además de su hogar, nadie más está autorizado.': 'No one outside their household is authorized.',
  'Relación': 'Relationship',
  'mismo nombre': 'same name',
  'mismo correo': 'same email',
  'mismo teléfono': 'same phone',
  'Posibles duplicados': 'Possible duplicates',
  'Se moverá todo lo de {mergeName} (contactos, donaciones, asistencia, programación…) a {keepName} y se eliminará el duplicado. Esta acción no se puede deshacer.':
    'Everything from {mergeName} (contact info, donations, attendance, scheduling…) will be moved to {keepName} and the duplicate will be deleted. This can’t be undone.',
  'Personas fusionadas': 'People merged',
  'Fusionar aquí': 'Merge here',
  'No hay campos personalizados': 'No custom fields',
  'Un administrador de Personas puede crearlos en Personas → Campos.': 'A People admin can create them in People → Fields.',
  'Campos guardados': 'Fields saved',
  'Guardar campos': 'Save fields',
  'Nueva nota': 'New note',
  'Sin categoría': 'No category',
  'restringida': 'restricted',
  'Guardar nota': 'Save note',
  'sistema': 'system',
  'Borrar@@nota': 'Delete',
  'Sin notas': 'No notes',
  'Pendiente': 'Pending',
  'Aprobada': 'Cleared',
  'Con observaciones': 'Flagged',
  'Vencida': 'Expired',
  'Verificación de antecedentes': 'Background check',
  'Realizada {date}': 'Completed {date}',
  'vence {date}': 'expires {date}',
  'Sin verificaciones registradas.': 'No background checks on file.',
  'Resultado': 'Result',
  'Vence@@verificación': 'Expires',
  'Registrar': 'Record',
  'Acceso a la plataforma': 'Platform access',
  'Tiene cuenta:': 'Has an account:',
  'Desactivada': 'Deactivated',
  'Los permisos se administran en Administración → Personal.': 'Permissions are managed in Administration → Staff.',
  'No tiene cuenta. Puede crearla desde el portal (Activar mi cuenta) con su correo registrado.': 'No account. They can create one from the portal (Activate my account) using their email on file.',
  'Idioma para mensajes': 'Language for messages',
  'Correos, WhatsApp, SMS y avisos llegan en este idioma.': 'Emails, WhatsApp, SMS and notifications arrive in this language.',
  'El de la iglesia': 'The church’s language',
  'También sirve la exportación de Planning Center tal como sale: entiende Person ID, Medical Notes (se guardan cifradas), Status, Marital Status, Household ID y Household Name.':
    'A Planning Center export works as is: it understands Person ID, Medical Notes (stored encrypted), Status, Marital Status, Household ID and Household Name.',
  '{n} persona trae notas médicas (se guardan cifradas).': '{n} person has medical notes (stored encrypted).',
  '{n} personas traen notas médicas (se guardan cifradas).': '{n} people have medical notes (stored encrypted).',
  '{n} aviso: no detiene la importación': '{n} warning: it does not stop the import',
  '{n} avisos: no detienen la importación': '{n} warnings: they do not stop the import',
} satisfies Record<string, string>;
